import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { InputElement } from "./styles/input";
import InputMask from "react-input-mask";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  maskType?:
    | "cnpj"
    | "tel"
    | "cpf"
    | "text"
    | "password"
    | "real"
    | "email"
    | "money"
    | "cep"
    | "custom";
  customMask?: string;
}

export function Input({
  maskType = "text",
  type = "text",
  customMask = "",
  ...props
}: InputProps) {
  const { register } = useFormContext();
  const [showText, setShowText] = useState(false);
  const [typeM, setType] = useState<string>(type);

  const maskMap: Record<string, string> = {
    cnpj: "99.999.999/9999-99",
    cpf: "999.999.999-99",
    tel: "(99) 99999-9999",
    real: "R$ /*9/",
    cep: "99999-999",
    email: "",
    money: "",
  };

  const mask = maskType === "custom" ? customMask : maskMap[maskType];
  const [value, setValue] = useState("");
  const inputProps = register(props.name);

  const InputElementContent = () => (
    <InputElement
      {...props}
      type={typeM}
      value={props.value}
      {...register(props.name)}
      id={props.name}
    />
  );

  const handleToggleShowText = () => {
    setShowText((prev) => !prev);
    setType((prev) => (prev === "password" ? "text" : "password"));
  };

  const formatCurrency = (value: string) => {
    return (
      "R$ " +
      value
        .replace(/\D/g, "") // Remove tudo que não for número
        .replace(/(\d)(\d{2})$/, "$1,$2") // Coloca a vírgula
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    );
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;
    inputValue = formatCurrency(inputValue);
    setValue(inputValue);
  };

  return maskType !== "money" ? (
    <div className="relative">
      <InputMask
        type={typeM}
        mask={mask}
        maskChar=""
        className={cn({
          "!pr-8": maskType === "password",
        })}
        {...props}
        onChange={inputProps.onChange}
        onBlur={inputProps.onBlur}
      >
        {InputElementContent}
      </InputMask>

      {maskType === "password" ? (
        <div>
          {showText ? (
            <Eye
              size={12}
              onClick={handleToggleShowText}
              className="absolute cursor-pointer right-0 bottom-3 mr-3"
            />
          ) : (
            <EyeOff
              size={12}
              onClick={handleToggleShowText}
              className="absolute cursor-pointer right-0 bottom-3 mr-3"
            />
          )}
        </div>
      ) : null}
    </div>
  ) : (
    <InputElement
      {...register(props.name)}
      id={props.name}
      type="text"
      value={value}
      onChange={handleChange}
      placeholder="R$ 0,00"
    />
  );
}
